module.exports = __webpack_public_path__ + "media/images/font/flaticon-38e5b911bb04cc783d5e6aa38a3b1d3c.eot";